import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  overflow: hidden;
  padding: 10px;
  z-index: 99999;
`;
